var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-quicksearch" },
    [
      !_vm.showSearch
        ? _c("global-button", {
            attrs: {
              icon: "search",
              theme: "secondary",
              "aria-label": _vm.$t("search.buttons.search"),
            },
            on: {
              click: function ($event) {
                _vm.showSearch = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSearch
        ? _c("global-button", {
            attrs: { icon: "close", theme: "primary", "aria-label": "close" },
            on: { click: _vm.closeSearch },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSearch
        ? _c("div", { staticClass: "global-quicksearch__expanded" }, [
            _c(
              "div",
              { staticClass: "global-quicksearch__search-container" },
              [
                _c("div", { staticClass: "global-quicksearch__search" }, [
                  _c(
                    "label",
                    {
                      staticClass: "global-quicksearch__label",
                      attrs: { for: "quicksearch-input" },
                    },
                    [
                      _c("global-button", {
                        attrs: {
                          icon: "search",
                          theme: "ghost",
                          "aria-label": _vm.$t("search.buttons.search"),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keyword,
                        expression: "keyword",
                      },
                    ],
                    ref: "inputfield",
                    staticClass: "global-quicksearch__input form__input",
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      id: "quicksearch-input",
                    },
                    domProps: { value: _vm.keyword },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.keyword = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.results &&
                _vm.totalResults > 0 &&
                Object.keys(_vm.results).length
                  ? [
                      _vm.results.suggestions && _vm.results.suggestions.length
                        ? _c("global-quicksearch-suggestions", {
                            attrs: {
                              suggestions: _vm.results.suggestions,
                              keyword: _vm.keyword,
                            },
                            on: { selected: _vm.selectSuggestion },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.results.shortcuts, function (shortcut, key) {
                        return _c("global-quicksearch-shortcut", {
                          key: key,
                          attrs: { shortcut: shortcut },
                        })
                      }),
                      _vm._v(" "),
                      _vm.results.boards && _vm.results.boards.count
                        ? _c("global-quicksearch-result", {
                            attrs: {
                              result: _vm.results.boards,
                              title: _vm.$t("search.categories.boards"),
                              resultsPageUrl: _vm.resultsPageUrl.length
                                ? _vm.resultsPageUrl +
                                  "?tx_salbase9_search[q]=" +
                                  _vm.keyword +
                                  "&tx_salbase9_search[cat]=boards"
                                : undefined,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.results.decor && _vm.results.decor.count
                        ? _c("global-quicksearch-result", {
                            attrs: {
                              result: _vm.results.decor,
                              title: _vm.$t("search.categories.decors"),
                              resultsPageUrl: _vm.resultsPageUrl.length
                                ? _vm.resultsPageUrl +
                                  "?tx_salbase9_search[q]=" +
                                  _vm.keyword +
                                  "&tx_salbase9_search[cat]=decor"
                                : undefined,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.results.structure && _vm.results.structure.count
                        ? _c("global-quicksearch-result", {
                            attrs: {
                              result: _vm.results.structure,
                              title: _vm.$t("search.categories.structures"),
                              resultsPageUrl: _vm.resultsPageUrl.length
                                ? _vm.resultsPageUrl +
                                  "?tx_salbase9_search[q]=" +
                                  _vm.keyword +
                                  "&tx_salbase9_search[cat]=structure"
                                : undefined,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.results.reference && _vm.results.reference.count
                        ? _c("global-quicksearch-result", {
                            attrs: {
                              result: _vm.results.reference,
                              title: _vm.$t("search.categories.references"),
                              resultsPageUrl: _vm.resultsPageUrl.length
                                ? _vm.resultsPageUrl +
                                  "?tx_salbase9_search[q]=" +
                                  _vm.keyword +
                                  "&tx_salbase9_search[cat]=reference"
                                : undefined,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.results.downloads && _vm.results.downloads.count
                        ? _c("global-quicksearch-result", {
                            attrs: {
                              result: _vm.results.downloads,
                              title: _vm.$t("search.categories.downloads"),
                              resultsPageUrl: _vm.resultsPageUrl.length
                                ? _vm.resultsPageUrl +
                                  "?tx_salbase9_search[q]=" +
                                  _vm.keyword +
                                  "&tx_salbase9_search[cat]=downloads"
                                : undefined,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.results.page && _vm.results.page.count
                        ? _c("global-quicksearch-result", {
                            attrs: {
                              result: _vm.results.page,
                              title: _vm.$t("search.categories.pages"),
                              resultsPageUrl: _vm.resultsPageUrl.length
                                ? _vm.resultsPageUrl +
                                  "?tx_salbase9_search[q]=" +
                                  _vm.keyword +
                                  "&tx_salbase9_search[cat]=page"
                                : undefined,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.resultsPageUrl.length
                        ? _c(
                            "a",
                            {
                              staticClass: "global-quicksearch__link-all",
                              attrs: {
                                href:
                                  _vm.resultsPageUrl +
                                  "?tx_salbase9_search[q]=" +
                                  _vm.keyword +
                                  "&tx_salbase9_search[cat]=all",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("search.buttons.showAll")) +
                                  " (" +
                                  _vm._s(_vm.totalResults) +
                                  ")"
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _vm.results && _vm.results.shortcuts.length
                  ? _vm._l(_vm.results.shortcuts, function (shortcut, key) {
                      return _c("global-quicksearch-shortcut", {
                        key: key,
                        attrs: { shortcut: shortcut },
                      })
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.totalResults === 0
                  ? [
                      _c("p", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("search.errors.noResult")) +
                            "\n                "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }